export default {
	state: {
		settingsDadosEntidade: {}
	},
	getters: {
		"settingsDadosEntidade": state => state.settingsDadosEntidade
	},
	mutations: {
		setSettingsDadosEntidade(state, payload) {
			state.settingsDadosEntidade = payload
		}
	},
	actions: {
		atualizarEstadoSettingsDadosEntidade({ commit }, payload) {
			commit('setSettingsDadosEntidade', payload)
		}
	}
};